/**
 * Local-calendar date helpers.
 *
 * The API stores session times as UTC instants, while forms and the calendar
 * work in the user's local time. Every conversion goes through these helpers
 * instead of Date#toISOString(), which returns the UTC calendar date (the
 * previous day for users east of UTC late in the evening). Sending a bare
 * "2026-10-20T20:30:00" made the server read local time as UTC, so sessions
 * moved by the user's offset on every save.
 */
const pad = (n) => String(n).padStart(2, '0')

const asDate = (value) => (value instanceof Date ? value : new Date(value))

/** YYYY-MM-DD in the user's time zone, for <input type="date"> and day keys. */
export function toLocalDateInput(value) {
  const d = asDate(value)
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

/** HH:MM in the user's time zone, for <input type="time">. */
export function toLocalTimeInput(value) {
  const d = asDate(value)
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`
}

/**
 * A form's local date and time ("2026-10-20", "20:30") as an ISO-8601 UTC
 * instant, so the server stores the moment the user meant.
 */
export function localDateTimeToISO(date, time) {
  return new Date(`${date}T${time}:00`).toISOString()
}
